/* SILNTPLAY — one shared reveal, loaded once. Elements in the first viewport reveal at init (no flash);
   the rest reveal via IntersectionObserver, with a rAF scroll safety-net so nothing is ever left hidden.
   JS-off / reduced-motion = everything visible. */
(function(){
  if(window.__tqsReveal) return;   /* idempotent — safe even if referenced more than once */
  window.__tqsReveal = 1;
  function run(){
    var els = [].slice.call(document.querySelectorAll('[data-reveal]'));
    if(!els.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(reduce){ for(var r=0;r<els.length;r++) els[r].classList.add('is-in'); return; }
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function(entries){
      for(var k=0;k<entries.length;k++){ if(entries[k].isIntersecting){ entries[k].target.classList.add('is-in'); io.unobserve(entries[k].target); } }
    }, { rootMargin:'0px 0px -5% 0px', threshold:0.01 }) : null;
    for(var i=0;i<els.length;i++){
      var el = els[i];
      if(el.getBoundingClientRect().top < vh){ el.classList.add('is-in'); }   /* first viewport: reveal now */
      else if(io){ io.observe(el); }
      else { el.classList.add('is-in'); }
    }
    /* safety-net: on scroll, reveal anything still hidden whose top has entered view.
       Covers fast scrolls, IO edge-cases, and themes whose scroll container is window. */
    var ticking = false;
    function sweep(){
      ticking = false;
      var h = window.innerHeight || document.documentElement.clientHeight;
      var pend = document.querySelectorAll('[data-reveal]:not(.is-in)');
      for(var j=0;j<pend.length;j++){ if(pend[j].getBoundingClientRect().top < h){ pend[j].classList.add('is-in'); if(io) io.unobserve(pend[j]); } }
      if(!pend.length){ window.removeEventListener('scroll', onScroll); window.removeEventListener('resize', onScroll); }
    }
    function onScroll(){ if(!ticking){ ticking = true; requestAnimationFrame(sweep); } }
    window.addEventListener('scroll', onScroll, { passive:true });
    window.addEventListener('resize', onScroll, { passive:true });
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', run, { once:true }); }
  else { run(); }
})();
